/*
 * Add asterisks to required input fields on contact page
 */
(function($){
    $('.wpcf7-validates-as-required').each(function(index, el) {
    	var input = $(this);
    	input.attr('placeholder', '*' + input.attr('placeholder'));
    });
})(jQuery);